import { render, staticRenderFns } from "./FirstAdmissionB.html?vue&type=template&id=16945faa&scoped=true&"
import script from "./FirstAdmissionB.vue?vue&type=script&lang=js&"
export * from "./FirstAdmissionB.vue?vue&type=script&lang=js&"
import style0 from "./FirstAdmissionB.scss?vue&type=style&index=0&id=16945faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16945faa",
  null
  
)

export default component.exports